import React from "react";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import NewUserForm from "../../components/NewUserForm";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectUserRole } from "../../slices/user";

const MobileNewUser = () => {
  const userRole = useAppSelector(selectUserRole);
  const navigate = useNavigate();

  const roleId = userRole === "admin" ? 6 : 5;

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      <div className="mb-4">
        <MobileSecViewsHeader title={"Nuevo Usuario"} route={"/users"} />
      </div>
      <NewUserForm
        roleToCreate={roleId}
        showForm={false}
        setShowForm={() => {}}
        extraFunc={() => navigate("/users")}
        isMobile={true}
      />
    </div>
  );
};

export default MobileNewUser;
